import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/app/ranking/components/RankingList.tsx");
